module.exports = __webpack_public_path__ + "fonts/TikTokTextMedium.bf7e5962.otf";